import React, { useContext, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Store } from "../Store";
import { Link, useNavigate } from "react-router-dom";
import classes from "../Assets/Styles/Signin.module.css";
import { ToastContainer, toast } from "react-toastify";
import { signInFirebaseUser, signInUser } from "../features/auth/api";
import { consumeSessionExpiredReason, SESSION_EXPIRED_MESSAGE } from "../features/auth/session";
import { golobalFont, labelColors } from "../utils/constants";
import { setStoredUserInfo } from "../utils/storage";

const SigninScreen = () => {
  const emailInputId = "signin-email";
  const passwordInputId = "signin-password";
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  // Read once on mount so the notice stays visible for the life of this page.
  const [sessionExpiredReason] = useState(consumeSessionExpiredReason);
  const sessionExpired = sessionExpiredReason !== null;

  useEffect(() => {
    if (sessionExpired) {
      console.warn(`Redirected to login because the session expired (${sessionExpiredReason}).`);
    }
  }, [sessionExpired, sessionExpiredReason]);

  const signIn = async (e) => {
    e.preventDefault();
    try {
      const { data } = await signInUser({
        email,
        password,
      });
      await signInFirebaseUser({ email, password });
      ctxDispatch({ type: "USER_SIGNIN", payload: data });
      setStoredUserInfo(data);

      if (data.isAdmin) navigate("/adminlanding");
      else navigate("/landing");
    } catch (err) {
      toast.error("Wrong Password/Email");
    }
  };

  useEffect(() => {
    ctxDispatch({ type: "PROJECT_FILE_CLEAR" });
    // localStorage.removeItem("projectFile");

    // if a user is already logged in, redirect to the appropriate landing page
    if (userInfo) {
      if (userInfo.isAdmin) navigate("/adminlanding");
      else navigate("/landing");
    }
  }, [ctxDispatch, navigate, userInfo]);

  return (
    <Grid
      item
      container
      direction="column"
      alignItems="center"
      marginTop={20}
      marginBottom={21.9}
    >
      <ToastContainer position="top-center" color="yellow" />
      <Grid
        item
        container
        justifyContent="center"
        width="40%"
        className={classes["HomeCardDetails"]}
      >
        <form onSubmit={signIn}>
          <Grid item container direction="column">
            <Grid item container color="white" justifyContent="center">
              <Grid item className={classes["header"]}>
                Login
              </Grid>
            </Grid>
            {sessionExpired && (
              <Grid item role="status" className={classes["sessionExpiredNotice"]}>
                {SESSION_EXPIRED_MESSAGE}
              </Grid>
            )}
            <Grid item fontSize="var(--font-size-header)" marginBottom={1.5}>
              <label htmlFor={emailInputId}>
                <div className={classes["labels"]}>Email</div>
              </label>
            </Grid>
            <input
              id={emailInputId}
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={classes["SampleInputForm"]}
            ></input>
            <Grid item fontSize="var(--font-size-header)" marginBottom={1.5} marginTop={1.5}>
              <label htmlFor={passwordInputId}>
                <div className={classes["labels"]}>Password</div>
              </label>
            </Grid>
            <input
              id={passwordInputId}
              type="password"
              placeholder="Enter your Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={classes["SampleInputForm"]}
            ></input>
            <Grid
              item
              container
              justifyContent="flex-start"
              marginTop={1}
              style={{
                width: "100%",
              }}
            >
              <Link
                to="/forgotpassword"
                style={{
                  textDecoration: "none",
                  color: `${labelColors}`,
                  fontFamily: `${golobalFont}`,
                  fontSize: "16px",
                }}
              >
                Forgot password?
              </Link>
            </Grid>
            <Grid item justifyContent="flex-start" marginTop={1.5}>
              <Link
                to="/signup"
                style={{
                  textDecoration: "none",
                  color: `${labelColors}`,
                  fontFamily: `${golobalFont}`,
                }}
              >
                <span>You don't have an account? Sign up</span>
              </Link>
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction="column"
            alignItems="center"
            marginTop={3.5}
            marginBottom={4}
          >
            <button type="submit" className={classes["SampleActiveButton"]}>
              Continue
            </button>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default SigninScreen;
